import { useContext, useMemo } from 'react';
import { getExtendedLogger } from './helpers';
import { Context } from './Provider';
function useExtendedLogger(extension) {
    var context = useContext(Context);
    return useMemo(function () { return getExtendedLogger(extension, context.log); }, [extension, context]);
}
export default useExtendedLogger;
//# sourceMappingURL=useExtendedLogger.js.map